import axios from 'axios'
import LocalStorageService from './refresh.service'
import store from '../store'

const localStorageService = LocalStorageService.getService()

axios.interceptors.request.use(
  (config) => {
    const token = localStorageService.getToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }

    const customParams = {
      client_device_type: 'crm',
    }

    const filialId = store.getters['app/getRequestFilialId']
    if (filialId) {
      customParams.cur_filial_id = filialId
    }

    // Глобально выбранный филиал — отдельным заголовком: cur_filial_id означает
    // филиал редактируемого заказа и правит на бэке меню, прайс-листы и корзину
    const globalFilialId = store.getters['branches/getGlobalFilialId']
    if (globalFilialId) {
      config.headers['X-Filial-Id'] = globalFilialId
    }

    const regionId = store.getters['app/getRequestRegionId']
    if (regionId) {
      customParams.cur_region_id = regionId
    }

    config.params = { ...customParams, ...config.params }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    const originalRequest = error.config

    const responseStatus = error.response ? error.response.status : 0

    // 402 - бэк отбил запрос заблокированного счёта (AccountBlocked). Если сокет
    // не донёс блокировку, поднимаем оверлей по первому же отказу.
    if (responseStatus === 402) {
      store.dispatch('billing/fetchPaymentAccountStatus').catch(() => {})
    }

    if (responseStatus === 401 && originalRequest.url.match(/auth\/login$/g) !== null) {
      return Promise.reject(error)
    }

    if (responseStatus === 401 && originalRequest.url.match(/\/refresh$/g) !== null) {
      LocalStorageService.clearToken()
      localStorage.removeItem('user')
      window.location.replace('/login')
      return Promise.reject(error)
    }

    if (responseStatus === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      /**
       * Пришлось так изъебнуться, так как в method: "patch" не передается url
       * Првоеряем не является ли url refresh'ем
       */
      if (
        error.response.config.method === 'patch' ||
        error.response.config.method === 'put' ||
        error.response.config.method === 'delete' ||
        (error.response.config.url && (
          error.response.config.url.match(/\/refresh/g) === null ||
          error.response.config.url.match(/\/login/g) === null
        ))
      ) {
        return store.dispatch('auth/refresh')
          .then((res) => {
            return axios(originalRequest)
          })
          .catch(() => {
            LocalStorageService.clearToken()
            localStorage.removeItem('user')
            window.location.replace('/login')
            return Promise.reject(error)
          })

        /* return axios.post(store.getters['api/authRefresh']).then((res) => {
          if (res.status === 200) {
            localStorageService.setToken(res.data.token)
            return axios(originalRequest)
          } else {
            window.location.replace('/login')
          }
        }) */
      }
    }

    return Promise.reject(error)
  },
)
